export default __webpack_public_path__ + "static/media/nfonew.4f1c4057.jpg";